const GOOGLE_ELEMENT_ID = 'google-maps-api'
const GOOGLE_API_URL = 'https://maps.googleapis.com/maps/api/js'
const GOOGLE_API_KEY_DEV = 'AIzaSyCml6DmEil93kDAHtjhW-j25sky5pXA23I'
const GOOGLE_API_KEY_PROD = 'AIzaSyAv6Awg95bdF_tLQPyjV4faGu92rB-sINE'
const GOOGLE_API_KEY = location.hostname === 'www.grecos.pl' ? GOOGLE_API_KEY_PROD : GOOGLE_API_KEY_DEV
const INTERVAL_VALUE = 50

export default class GoogleMapsService {
  static isGoogleMapsApiLoaded = () => document.getElementById(GOOGLE_ELEMENT_ID)

  /**
   * Because we don't use callback as parameter in <script> tag with value of
   * method name in window object, we can simply check for google object with this code.
   * We don't like globals.
   * @param {Function} cb resolves promise
   */
  static waitTillGoogleApiIsNotLoaded (cb) {
    const x = setInterval(() => {
      if (window.google) {
        log.debug('GoogleMaps API loaded')
        cb()
        clearInterval(x)
      }
    }, INTERVAL_VALUE)
  }

  static loadApi () {
    return new Promise((resolve, reject) => {
      const s = 'script'
      const firstTag = document.getElementsByTagName(s)[0]

      if (GoogleMapsService.isGoogleMapsApiLoaded()) {
        reject('GoogleMaps API is already loaded.')
        return
      }

      const js = document.createElement(s)
      js.id = GOOGLE_ELEMENT_ID
      js.src = `${GOOGLE_API_URL}?key=${GOOGLE_API_KEY}`
      js.async = ''
      js.defer = ''
      firstTag.parentNode.insertBefore(js, firstTag)

      GoogleMapsService.waitTillGoogleApiIsNotLoaded(resolve)
    })
  }

  init () {
    if (!GoogleMapsService.isGoogleMapsApiLoaded()) {
      log.debug('GoogleMaps API not loaded, try to load')

      return GoogleMapsService.loadApi()
        .catch(log.error)
    }

    return false
  }
}



// WEBPACK FOOTER //
// ./src/services/GoogleMapsService.js